'use client';

import React, { useEffect, useState, useRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { isWorkbook } from '@/utils/spreadsheets';
import univerService from '@/services/univerjs';
import envConfig from '@/config/environment';
import useSelections from './Selections/useSelections';
import Selections from './Selections';
import UniverSheet from './UniverSheet';
import errors from './errors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PREFIX = 'components: Spreadsheet:';
const IS_DEVELOPMENT = envConfig.isDevelopment;

const Spreadsheet = _ref => {
  let {
    data,
    meta,
    className = '',
    editable = false,
    syncedAt = 0,
    addingNewSelection = false,
    activeSheetIndex = 0,
    activeSelection = '',
    selections: selectionSettings = [],
    onSelectionClick = () => undefined,
    onSheetChange = () => undefined,
    onChange = () => undefined,
    onSelect = () => undefined,
    onWarn = () => undefined,
    onError = () => undefined
  } = _ref;
  const {
    0: isUniverLoaded,
    1: setIsUniverLoaded
  } = useState(false);
  const {
    0: scrollOffsetX,
    1: setScrollOffsetX
  } = useState(0);
  const {
    0: scrollOffsetY,
    1: setScrollOffsetY
  } = useState(0);
  const lastSyncedAt = useRef(syncedAt);
  const selections = useSelections({
    configs: selectionSettings,
    activeSheetIndex,
    worksheetData: data[activeSheetIndex] || [[]],
    worksheetGrid: (meta.grids || [])[activeSheetIndex] || {}
  });
  const {
    0: univerWorkbook,
    1: setUniverWorkbook
  } = useState(null);
  useEffect(() => {
    if (!data) return;
    univerService.workbookToUniverWorkbook({
      workbook: isWorkbook(data) ? data : [data],
      workbookMeta: meta
    }).then(result => {
      setUniverWorkbook(result); // NOTE: Ensure latest workbook data
      // has propagated before syncing

      setTimeout(() => {
        lastSyncedAt.current = syncedAt; // Inform UniverSheet needs to sync
      }, 1000);
    }).catch(err => {
      onError(errors.createWorkbookGenerateError(PREFIX, err));
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, syncedAt]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [IS_DEVELOPMENT ? /*#__PURE__*/_jsx("style", {
      type: "text/css",
      children: `nextjs-portal { display: none; }`
    }) : /*#__PURE__*/_jsx(_Fragment, {}), univerWorkbook ? /*#__PURE__*/_jsx(ErrorBoundary, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {}),
      onError: err => onError(errors.createUnknownUniverError(PREFIX, err)),
      children: /*#__PURE__*/_jsx(UniverSheet, {
        className: className,
        data: univerWorkbook,
        syncedAt: lastSyncedAt.current,
        editable: editable,
        targetSelection: activeSelection,
        onSelect: onSelect,
        onChange: onChange,
        onSheetSelect: onSheetChange,
        onScroll: _ref2 => {
          let {
            x,
            y
          } = _ref2;
          setScrollOffsetX(x);
          setScrollOffsetY(y);
        },
        onLoad: () => setIsUniverLoaded(true),
        onWarn: function () {
          return isUniverLoaded && onWarn(...arguments);
        },
        onError: onError
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), !editable && isUniverLoaded ? /*#__PURE__*/_jsx(Selections, {
      isAdding: addingNewSelection,
      activeSheet: data[activeSheetIndex],
      worksheetGrid: (meta.grids || [])[activeSheetIndex],
      offsetX: scrollOffsetX,
      offsetY: scrollOffsetY,
      items: selections,
      onClick: onSelectionClick
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default Spreadsheet;